import React from "react";
import { connect } from "react-redux";
import _, { truncate } from "lodash";
import { push } from "react-router-redux";
import PropTypes from "prop-types";
import { getFirstNameLastInitial, properCase } from "LIB/formatters/text";
import { dollars } from "LIB/formatters/currency";
import {
  DataTable,
  SearchPropTypes,
  CompanyName,
  PartNumber,
  NoteTooltip
} from "MODULES/shared/components";
import HoverFlag from "MODULES/parts/components/HoverFlag";
import { OUTGOING_LINE_ITEMS } from "MODULES/OutgoingQuotes/constants";
import UpdatedTrackedFieldsAt from "MODULES/shared/components/UpdatedTrackedFieldsAt/UpdatedTrackedFieldsAt";
import { EXCHANGE_ONLY } from "MODULES/IncomingQuotes/constants";
import { CONDITIONS_WITH_SERVICEABLE } from "APP_ROOT/constants";
import { LookingForFlags } from "MODULES/OutgoingQuotes/shared/LookingForFlags";

function renderRow(r, pushHistory) {
  const handleMailto = e => {
    e.stopPropagation();
  };

  return (
    <tr
      key={r.id}
      className="clickable"
      onClick={() => pushHistory(`/outgoing-quotes/${r.quote_uuid}`)}
    >
      <td>{r.quote_code}</td>
      <td>
        <UpdatedTrackedFieldsAt record={r} />
      </td>
      <td>{r.created_by && getFirstNameLastInitial(r.created_by.full_name)}</td>
      <td className="text-center">
        {OUTGOING_LINE_ITEMS.quoteType[r.quote_type].label}
      </td>
      <td>
        <CompanyName flattenedCompany={r} truncateAt={16} />
      </td>
      <td>{truncate(r.contact_name, 14)}</td>
      <td>
        <a href={`mailto:${r.contact_email}`} onClick={handleMailto}>
          {truncate(r.contact_email, 12)}
        </a>
      </td>
      <td>{r.serial_number && truncate(r.serial_number, 12)}</td>
      <td>
        {truncate(getFirstNameLastInitial(_.get(r, "buyer.full_name")), 14)}
      </td>
      <td>{r.part && <PartNumber part={r.part} />}</td>
      <td>{r.condition && CONDITIONS_WITH_SERVICEABLE[r.condition].label}</td>
      <td className="text-center">{r.quantity}</td>
      <td className="text-right padding-right-zero">
        <LookingForFlags lineItem={r} />
        {_.get(r, "no_interest") && (
          <HoverFlag text="No Interest" abbr="NI" inline />
        )}
      </td>
      <td className="text-center padding-horizontal-zero">
        {r.quote_type === EXCHANGE_ONLY
          ? dollars(r.exchange_fee)
          : dollars(r.price_per_unit)}
      </td>
      <td className="text-right">
        {_.get(r, "inventory_suggested_retail") &&
          dollars(r.inventory_suggested_retail)}
      </td>
      <td className="text-center">{_.get(r, "part.sellable_quantity")}</td>
      <td className="text-center">
        {!_.isEmpty(r.follow_up_feedback) && (
          <NoteTooltip
            note={`Follow Up Feedback: ${properCase(r.follow_up_feedback)}`}
            color="#f44336"
          />
        )}
      </td>
    </tr>
  );
}

export function Table({ pushHistory, isLoading, pageActions, results }) {
  return (
    <DataTable loading={isLoading} refresh={pageActions.expire}>
      <DataTable.Head>
        <th>Quote #</th>
        <th>Date</th>
        <th>Created By</th>
        <th className="text-center">Type</th>
        <th>Customer</th>
        <th>Contact</th>
        <th>Email</th>
        <th>Serial Number</th>
        <th>Buyer</th>
        <th>Part #</th>
        <th>Cond</th>
        <th className="text-center">Qty</th>
        <th className="text-right" />
        <th className="text-center">Price Per Unit</th>
        <th className="text-right">SRP</th>
        <th className="text-center">Sellable</th>
        <th className="text-center">FU</th>
      </DataTable.Head>
      <DataTable.Body>
        {results.map(r => renderRow(r, pushHistory))}
      </DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  pushHistory: PropTypes.func.isRequired,
  ...SearchPropTypes
};

export default connect(undefined, { pushHistory: push })(Table);



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/Search/Table.jsx